var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWalletSolid = function SvgWalletSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.39 1.75a2.36 2.36 0 0 1 2.36 2.36V6.5H3.58l8.858-4.55a2.4 2.4 0 0 1 .952-.2m1.675 6c1.363 0 2.462 0 3.327.116.9.121 1.658.38 2.26.983s.86 1.36.982 2.26c.116.864.116 1.963.116 3.327v1.128c0 1.363 0 2.463-.116 3.328-.121.9-.38 1.658-.983 2.26s-1.36.86-2.26.982c-.864.116-1.963.116-3.326.116h-6.13c-1.362 0-2.462 0-3.327-.116-.9-.121-1.657-.38-2.26-.983s-.86-1.36-.982-2.26c-.116-.864-.116-1.963-.116-3.326V8.5l.004-.077A.75.75 0 0 1 3 7.75zm2.435 6a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
  })));
};
export default SvgWalletSolid;